"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var picker_field_1 = require("../../../../components/pricing/inputs/picker-field/picker-field");

var constants_1 = require("../../../../theming/pricing-system/constants");

var pickerViewStyle = {
  minWidth: '10em'
};

var GroupPickerField = function (_super) {
  __extends(GroupPickerField, _super);

  function GroupPickerField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onSelect = function (item) {
      var onSelect = _this.props.onSelect;

      if (onSelect) {
        var groups = _this.props.groups || [];
        var selectedGroup = groups.find(function (group) {
          return group.ncpdp === item.value;
        });
        onSelect(selectedGroup);
      }
    };

    return _this;
  }

  GroupPickerField.prototype.render = function () {
    var selectedNcpdp = this.props.currentGroup ? this.props.currentGroup.ncpdp : '';
    return react_1.default.createElement(picker_field_1.PickerField, {
      items: this.getPickerItems(),
      viewStyle: this.props.viewStyle,
      label: constants_1.GroupPickerFieldContent.label,
      labelPosition: this.props.labelPosition,
      labelTextStyle: this.props.labelTextStyle,
      pickerViewStyle: pickerViewStyle,
      onSelect: this.onSelect,
      selectedItemValue: selectedNcpdp
    });
  };

  GroupPickerField.prototype.getPickerItems = function () {
    var clonedGroups = (this.props.groups || []).slice();

    var compareFunction = function compareFunction(a, b) {
      return a.name.localeCompare(b.name);
    };

    var sortedGroups = clonedGroups.sort(compareFunction);
    var sortedItems = sortedGroups.map(function (group) {
      return {
        text: group.name,
        value: group.ncpdp
      };
    });
    var emptyItem = {
      text: '',
      value: ''
    };
    sortedItems.unshift(emptyItem);
    return sortedItems;
  };

  return GroupPickerField;
}(react_1.default.PureComponent);

exports.GroupPickerField = GroupPickerField;